export default {
  // 渲染 loading 组件前的等待时间。默认：50ms.
  ROUTER_LOADING_DALAY: 50,
  // 最长等待时间。超出此时间( 5s )则渲染 error 组件。默认：Infinity
  ROUTER_LOADING_TIMEOUT: 5000,

  EVENT_TOKE: 'Authorization',
  AJAX_SUCCESS: 200,
  RES_CODE: 0, // 成功
  RES_CODE1: -1, // 成功
  NO_TOKEN: -100,
  INVALID_TOKEN: -101,
  URL_IMG: 'https://www.chinaswa.org',
  URL_DOWN: 'https://www.chinaswa.org',
  PUBLICKEY: 'MIICdgIBADANBgkqhkiG9w0BAQEFAASCAmAwggJcAgEAAoGBAI8USycGS9Oxn5x5NOkFrf6SMkYR5s6zXAnyxnCnGLoRUMVyQdX6F4cNnxSTzDUbi2b8zvaoDY7/k3YQKnY6+mWFSsL9ipwYk1A2zCUMHgkbf2+rSZCM1Ig3df+/oiDvng8BYOL3dhQKx3lnGgVuOWIPi+yA5Z5a0ggs/Bt6iI1PAgMBAAECgYBG58mul0IwsM/mnXKJIFVv2UeszeZR/TTZgUSyQzzPyRD8KHlT71KFjUyOyAflMbdN3G88cV/2w9VyJuTEHspDkspbwUX1Gtm/XAZiX4xNUyTPGxG/4Yxu5uH1akYL4obqapoqquyusn4Qnje3n2FSKmdTOQbuuJlRRD5qUAElYQJBANLqjeMH1JoZRM40Re6rbz0d3sBhi0A6Z0Rk9EDJXM3T/PNCPTdSISXy0xRhtfle55jTkLLLS2TL/cbetRrp0bkCQQCtqapxF4O3TRUfDcVvZu2tXkDp5AJPO3WQIzABGPE2yAeLRQYoYWrqZ8FjeZmy3RVGAwW2WC+e5I7O+6C/B/tHAkBBQp4AX03jGGp3uyjgPl8+890WfZgOmYOWX/5LhYKXlT4xLo+ubFUhXs79AXbC4CCc4ulkyQ5c89lkDUjQOQTRAkAEcvdR5GdUd94VqJWpT/rA2UxScav5ea1+Xtho/smXPLKsx7zrpetGTBgxQzlD0tQrsgIgdMvrhzF9bgblPgAbAkEAtoKd2YewuQQAbO/0okPQrTUZRNcA12IFdST3CmERYijxD5YOQ/YwWPjtB7MBuRW9adjv2pmOxoUr4n0PUOmYJQ=='
}



// WEBPACK FOOTER //
// ./src/constant.js